import userLoggedIn from '../scripts/user-logged-in';
import DashboardLite from './dashboard/_dashboard-lite';
import maybeBlacklistedOverlay from '../components/maybe-blacklisted-overlay'

if(document.querySelector('.dashboard')) {

  userLoggedIn().then(token => {

    if(token === false) {
      window.location.href = window.site.home + '/logout';
      return;
    }

    if(maybeBlacklistedOverlay()) {
      return;
    }

    new DashboardLite();

  });

}
